export default [
  {
    key: "firstName",
    label: "field.firstName",
    type: "text",
  },
  {
    key: "lastName",
    label: "field.lastName",
    type: "text",
  },

  {
    key: "image",
    label: "field.botIcon",
    initKey: "profilePicture",
    rules: "size:10000",
    type: "single-image",
    pw: 150,
    ph: 150,
    fullWidth: false,
    cols: 12,
  },
];
